import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "5px",
});

export const IconInfoContainer = styled(Grid)({
  display: "flex",
  gap: "10px",
  alignContent: "center",
});

export const TitleDescriptionContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));
